import { ConfirmModal, Toasts, useModalContext } from '@fourthwall/components';
import { useDisconnectPlatformAppMutation } from '../../../queries/useDisconnectPlatformAppMutation';
import { usePlatformAppQuery } from '../../../queries/usePlatformAppQuery';
export const usePlatformApp = (appId) => {
    const { platformAppQuery: { data: platformApp, refetch, isLoading }, } = usePlatformAppQuery([{ appId }]);
    const { open } = useModalContext();
    const { disconnectPlatformAppMutation } = useDisconnectPlatformAppMutation(appId);
    const getStatus = () => {
        if (!platformApp)
            return undefined;
        if (platformApp.state === 'UNINSTALLED' || platformApp.state === 'NEEDS_RECONNECT')
            return 'NOT_CONNECTED';
        if (platformApp.state === 'INSTALLED')
            return 'CONNECTED';
    };
    const status = getStatus();
    const name = platformApp?.displayName;
    const getConnectBar = () => {
        const connectBarBase = {
            logoSrc: platformApp?.iconUrl || '',
            description: status === 'CONNECTED' ? `Connected to ${name}` : `Connect to ${name}`,
            disabled: false,
        };
        if (!status)
            return undefined;
        const redirectUri = platformApp.redirectUri || '';
        if (status === 'NOT_CONNECTED') {
            const onConnect = () => {
                const url = `/admin/platform-apps/${appId}/connect?redirect_uri=${redirectUri}`;
                window.location.assign(url);
            };
            return {
                ...connectBarBase,
                onConnect,
            };
        }
        if (status === 'CONNECTED') {
            const onDisconnect = () => {
                open(ConfirmModal, {
                    title: `Are you sure you want to disconnect from ${name}?`,
                    confirmLabel: 'Yes, disconnect',
                    confirmAppearance: 'destructive',
                    onConfirm: () => {
                        const toastId = 'disconnectPlatformAppMutation';
                        Toasts.notify(`Disconnecting from ${name}...`, {
                            toastId,
                            type: 'info',
                            autoClose: false,
                        });
                        disconnectPlatformAppMutation.mutate(undefined, {
                            onSuccess: () => {
                                refetch();
                                Toasts.notify(`Disconnected from ${name} successfully.`, { type: 'success' });
                                Toasts.dismiss(toastId);
                            },
                        });
                    },
                });
            };
            return {
                ...connectBarBase,
                disabled: disconnectPlatformAppMutation.isLoading,
                onDisconnect,
            };
        }
    };
    return {
        connectBar: getConnectBar(),
        name,
        description: platformApp?.description,
        learnMoreUrl: platformApp?.learnMoreUrl,
        hmac: platformApp?.hmac && platformApp?.hmacTimestamp
            ? {
                signature: platformApp.hmac,
                timestamp: platformApp.hmacTimestamp,
            }
            : undefined,
        settingsUrl: platformApp?.settingsUrl,
        status,
        isLoading,
    };
};
